module.exports = __webpack_public_path__ + "img/1.6edd0bb4.png";